module.exports = __webpack_public_path__ + "statics/img/UserReviews-2.733557fb.png";